(()=>{
 const section=document.querySelector('#shopify-section-knr-061');
 const root=section?.querySelector('.ks-handles-head');
 if(!root)return;
 const heading=root.querySelector('h1');
 if(heading&&!heading.querySelector('.sx-headline-benefit')){
  const text=heading.textContent;
  const end=text.indexOf('.');
  if(end>-1){
   const benefit=document.createElement('span');benefit.className='sx-headline-benefit';benefit.textContent=text.slice(0,end+1);
   heading.replaceChildren(benefit,document.createTextNode(text.slice(end+1)));
  }
 }
 const photos=Array.from(section.querySelectorAll('.hge-option-grid img'));
 root.querySelectorAll('.ks-pdp-option').forEach(button=>{
  const name=button.querySelector('strong')?.textContent.trim();
  if(!name||button.querySelector('.sx-kit-photo'))return;
  const photo=photos.find(image=>image.alt.toLowerCase()==='swissies x '+name.toLowerCase());
  if(!photo)return;
  const image=document.createElement('img');image.src=photo.src.replace(/([?&])width=\d+/,'$1width=240');
  image.alt='';image.width=122;image.height=70;image.className='sx-kit-photo';button.prepend(image);
 });
 root.querySelectorAll('a.ks-assurance-item').forEach(link=>{
  const item=document.createElement('div');item.className=link.className;
  while(link.firstChild)item.append(link.firstChild);
  link.replaceWith(item);
 });
})();
